import * as server from '../entries/pages/(app)/_layout.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/_layout.svelte.js')).default;
export { server };
export const server_id = "src/routes/(app)/+layout.server.ts";
export const imports = ["_app/immutable/nodes/2.D-cHOhbx.js","_app/immutable/chunks/disclose-version.BL6hcnec.js","_app/immutable/chunks/index-client.rXPpudJw.js","_app/immutable/chunks/legacy.C_sX5KDq.js","_app/immutable/chunks/attributes.Dqs2QQcr.js","_app/immutable/chunks/events.0Dsuk1hn.js","_app/immutable/chunks/SmuiElement.DcOvIuB6.js","_app/immutable/chunks/if.DRJZN_wj.js","_app/immutable/chunks/actions.DwIXx_q0.js","_app/immutable/chunks/props.BHWyiohh.js","_app/immutable/chunks/ClassAdder.RS6v2qau.js","_app/immutable/chunks/svelte-component.KoQ-FyZF.js"];
export const stylesheets = [];
export const fonts = [];
